import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  dialog: {
    position: 'absolute',
    width: '504px',
  },
  button: {
    width: '100px',
    borderRadius: '24px',
    height: '40px',
    textTransform: 'none',
  },
  dialogTitle: {
    textAlign: 'center',
  },
  dialogContent: {
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '20px',
    overflow: 'hidden',
    marginBottom: '5px',
  },
  dialogAction: {
    justifyContent: 'center',
    marginBottom: '15px',
  },
  titleIconWarning: {
    margin: '15px',
    backgroundColor: '#EBF6EB',
    color: '#F2BD00',
    fontSize: '6rem',
    '& .MuiSvgIcon-root': {
      fontSize: '6rem',
    },
  },
  iconeSVG: {
    width: '50px',
    height: '50px',
  },
}))
